export default "__VITE_ASSET__0cc1fe1a__"